import { FC, useState } from 'react';
import { ReactComponent as CopyToClipboardIcon } from '../../assets/copy-to-clipboard.svg';
import { ReactComponent as CopyToClipboardDoneIcon } from '../../assets/copy-to-clipboard-done.svg';
import { Tooltip } from '../Tooltip/Tooltip';

type CopyClipboardButtonProps = {
  onClick: () => void;
  title?: string;
};

export const CopyClipboardButton: FC<CopyClipboardButtonProps> = ({
  title = 'Copy to Clipboard',
  onClick,
}) => {
  const [copyDone, setCopyDone] = useState(false);

  const handleClickCopyToClipboard = () => {
    const copyToClipBoardBtn = document.getElementById('CopyToClipBoardBtn');
    // Hide the copy button when clicked
    if (copyToClipBoardBtn) {
      copyToClipBoardBtn.style.opacity = '0';
    }

    onClick();

    // Show the button again
    setCopyDone(true);
    if (copyToClipBoardBtn) {
      copyToClipBoardBtn.style.opacity = '1';
    }
    setTimeout(() => {
      setCopyDone(false);
    }, 2000);
  };

  return (
    <div
      className="flex justify-center items-center transition-all duration-75"
      id="CopyToClipBoardBtn"
    >
      <Tooltip title={title}>
        <div
          className={`cursor-pointer border rounded-[0.8rem] group bg-white 
                      transition-all -pt-4 w-[2.9rem] flex items-center justify-center
                      hover:border-gray-400 h-[2.9rem]`}
          onClick={handleClickCopyToClipboard}
        >
          {!copyDone ? (
            <CopyToClipboardIcon className="fill-black hover:fill-black mr-1 -mt-1" />
          ) : (
            <CopyToClipboardDoneIcon className="inline-block float-left mr-1 -mt-1" />
          )}
        </div>
      </Tooltip>
    </div>
  );
};
